export default __webpack_public_path__ + "static/media/img-c-00-btn-egt@3x.6d7d56d0.png";